import React from 'react'

import {useDeviceLayout} from '@daedalus/atlas/context/deviceLayout'
import {Stack} from '@daedalus/atlas/helpers/Stack'
import {SkeletonLoader} from '@daedalus/atlas/SkeletonLoader'

export const HotelDetailsLoading = () => {
  const {isMobile} = useDeviceLayout()

  if (isMobile) {
    return (
      <Stack space="s200">
        <SkeletonLoader width={60} height={16} />
        <SkeletonLoader width={150} height={28} />
      </Stack>
    )
  }

  return (
    <Stack space="s200">
      <SkeletonLoader width={68} height={16} />
      <SkeletonLoader height={36} />
    </Stack>
  )
}
